import { useTheme } from "styled-components";
import { NAMESPACE } from "..";
export const getActiveColorScheme = (props) => props.theme[NAMESPACE].defaults.colorScheme;
export const useActiveColorScheme = () => {
    const theme = useTheme();
    return getActiveColorScheme({ theme });
};
export const colorSchemeVariant = (obj) => (props) => {
    const activeColorScheme = getActiveColorScheme(props);
    return obj[activeColorScheme] || obj.default || "";
};
